
import React, {
	createContext,
	ReactNode,
	useCallback, useEffect, useMemo, useState,
} from 'react'
import { useWeb3React } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { TWeb3Context } from '../@types/auth'

const NETWORK = process.env.REACT_APP_BB1_CONTRACT_NETWORK

const Web3Context = createContext<TWeb3Context | null>(null)

function OurWeb3Provider({ children }: { children: ReactNode }) {
	const {
		library,
		chainId,
		account,
		activate,
		active,
		deactivate,
		error,
		connector,

	} = useWeb3React<Web3Provider>()

	const [desiredNetwork] = useState<number>(() => {
		if (NETWORK === 'Main') {
			return 1
		}
		if (NETWORK === 'Rinkeby') {
			return 4
		}
		return 1
	})

	const toHex = (num:any):string => {
		const val = Number(num)
		return `0x${val.toString(16)}`
	}
	const switchChain = useCallback(async () => {
		await library?.provider?.request?.({
			method: 'wallet_switchEthereumChain',
			params: [{ chainId: toHex(desiredNetwork) }],
		})
	}, [library, desiredNetwork])

	const signMessage = useCallback(async (account:string, message: string):Promise<any> => {
		const sig = await library?.provider?.request?.({
			method: 'personal_sign',
			params: [message, account],
		})
		return sig
	}, [library])

	const isWhitelisted = useCallback(async (account:string):Promise<boolean> => {
		const functions = getFunctions()
		const fn = httpsCallable(functions, 'auth-fns-isWhitelisted')
		const { data }:{data:any} = await fn({ address: account })
		return data?.status === 'WHITELISTED'
	}, [])

	const value = useMemo(() => ({
		account,
		switchChain,
		chainId,
		desiredNetwork,
		activate,
		active,
		signMessage,
		deactivate,
		error,
		isWhitelisted,
	} as TWeb3Context), [error, account, switchChain, chainId, desiredNetwork, activate, active, signMessage, deactivate, isWhitelisted])

	return (
		<Web3Context.Provider
			value={value}
		>
			{children}
		</Web3Context.Provider>
	)
}

export { Web3Context, OurWeb3Provider }
